import { useEffect, useState } from "react";
import {
  getFieldValuesByTableAndId,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../../api/keyvalue";
import { validateRequestConsignee } from "../../../validations/validateRequestCreation";
import SearchDropdown from "../../../input/SearchDropdown";
import Grid from "../../../Grid";
import ButtonRenderer from "../../../renderer/ButtonRenderer";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../../store/request-slice";
import UIMessage from "../../../UIMessage";
import Dropdown from "../../../input/Dropdown";
import Input from "../../../input/Input";
import Button from "../../../input/Button";
import { ResizableScrollingTextRenderer } from "../../../renderer/StyleRenderer";
import { FORMS, MODULES } from "../../../../const";
import { validateQuickRequestConsignee } from "../../../validations/ValidateQuickRequestCreation";
import DeleteButtonRenderer from "../../../renderer/DeleteButtonRenderer";

const FORM = FORMS.QUICK_REQUEST.CONSIGNEE.form;

const QuickRequestConsignee = ({ dropdown, editMode }) => {
  const [requestConsignee, setRequestConsignee] = useState({
    rcoLocation: null,
    rcoLocationValue: "",
    rcoConsignee: null,
    rcoConsigneeValue: "",
    rcoConsignmentType: null,
    rcoConsignmentTypeValue: "",
    rcoCbm: "",
    rcoQty: "",
    rcoActive: 1,
  });

  const [currentTotalCBM, setCurrentTotalCBM] = useState(0);
  const [filteredList, setFilteredList] = useState([]);
  const multiConsigneeType = useSelector(
    (state) => state.request.reqMultiConsignee,
  );

  const items = useSelector((state) => state.request.requestConsigneesRequests);
  const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);

  const validationErrors = useSelector(
    (state) => state.request.consigneeValidationErrors,
  );

  const dispatch = useDispatch();
  const vehMaxCbm = useSelector((state) => state.request.vehicleMaxCbm);
  const remainingCbm = parseFloat(vehMaxCbm) - currentTotalCBM;

  useEffect(() => {
    const filteredItems = items.filter((item) => {
      if (item === null) {
        return false;
      }
      return item.rcoActive === 1;
    });
    if (multiConsigneeType === 1) {
      const totalCBM = filteredItems.reduce(
        (acc, item) => acc + parseFloat(item.rcoCbm),
        0,
      );
      const totalQTY = filteredItems.reduce(
        (qty, item) => qty + parseFloat(item.rcoQty),
        0,
      );
      setCurrentTotalCBM(totalCBM);
      dispatch(
        requestActions.setRequest({
          reqCbm: totalCBM,
          reqQty: totalQTY,
        }),
      );
    }

    setFilteredList(filteredItems);
  }, [items, dispatch, multiConsigneeType]);

  const locationCustomerId = useSelector(
    (state) => state.request.reqLCustomerId,
  );

  const editModeConsigneeCount = useSelector(
    (state) => state.request.editModeConsigneeCount,
  );

  useEffect(() => {
    if (editMode) {
      setCount(editModeConsigneeCount);
    }
  }, [editModeConsigneeCount, editMode]);

  const [locationOptions, setLocationOptions] = useState([]);

  const requestLocations = useSelector(
    (state) => state.request.requestLocationsRequests,
  );
  const hasLocErrors = useSelector((state) => state.request.hasLocErrors);

  useEffect(() => {
    (async () => {
      const locationData = [];
      if (!hasLocErrors) {
        for (let location of requestLocations) {
          if (location.rlkActive === 1) {
            const locationResponse = await getOtherRefDetails({
              type: "location_customer",
              value: locationCustomerId?.toString(),
              param2: location?.rlkLocation?.toString(),
            });
            const locationDetails =
              locationResponse && locationResponse.length > 0
                ? locationResponse[0]
                : {};
            locationData.push({
              key: location.rlkLocation,
              value: location.rlkLocation,
              text: locationDetails.retField1,
            });
          }
        }
      }

      setLocationOptions(locationData);
    })();
  }, [hasLocErrors, requestLocations, locationCustomerId]);

  const [isAddLoading, setIsAddLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [errors, setErrors] = useState("");
  const [count, setCount] = useState(2);
  const [currentItem, setCurrentItem] = useState({});

  const [searchFieldReset, setSearchFieldReset] = useState(false);

  useEffect(() => {
    if (Object.keys(currentItem).length > 0) {
      setRequestConsignee({
        ...currentItem,
        rcoLocationValue: currentItem.rcoLocationValue,
        rcoConsigneeValue: currentItem.rcoConsigneeValue,
        rcoConsignmentTypeValue: currentItem.rcoConsignmentTypeValue,
      });
    }
  }, [editMode, currentItem]);

  useEffect(() => {
    if (buttonClicked) {
      setRequestConsignee({
        rcoLocation: null,
        rcoLocationValue: "",
        rcoConsignee: null,
        rcoConsigneeValue: "",
        rcoConsignmentType: null,
        rcoConsignmentTypeValue: "",
        rcoCbm: "",
        rcoQty: "",
        rcoActive: 1,
      });
      setSearchFieldReset(true);
      setCurrentItem({});
      setErrors({});
      setButtonClicked(false);
    }
  }, [buttonClicked]);

  const onAddClick = async () => {
    setIsAddLoading(true);

    const requestConsigneeErrors = validateQuickRequestConsignee(requestConsignee);

    if (Object.keys(requestConsigneeErrors).length === 0) {
      const locationResponse = await getOtherRefDetails({
        type: "location_customer",
        value: locationCustomerId.toString(),
        param2: requestConsignee.rcoLocation.toString(),
      });
      const locationDetails =
        locationResponse && locationResponse.length > 0
          ? locationResponse[0]
          : {};

      const rcoLocationValue = locationDetails.retField1;

      const consigneeResponse = await getFieldValuesByTableAndId({
        tableName: "masterdata.tms_m_stakeholder",
        primaryKey: "stk_id",
        fieldNames: "stk_name",
        ids: requestConsignee.rcoConsignee.toString(),
      });

      const rcoConsigneeValue = consigneeResponse
        ? consigneeResponse[0].field1
        : "";

      const rcoConsignmentTypeValue = await getTextByValueAndKey(
        "consignment_type",
        requestConsignee.rcoConsignmentType,
      );
      if (!requestConsignee.rcoId) {
        if (!requestConsignee.id) {
          dispatch(
            requestActions.addConsignee({
              ...requestConsignee,
              rcoCbm: parseFloat(requestConsignee.rcoCbm),
              rcoQty: requestConsignee.rcoQty
                ? parseInt(requestConsignee.rcoQty)
                : null,
              rcoLocationValue,
              rcoConsigneeValue,
              rcoConsignmentTypeValue,
              id: count,
            }),
          );
          setCount((prevState) => prevState + 1);
        } else {
          dispatch(
            requestActions.updateNonPersistedConsignee({
              consignee: {
                ...requestConsignee,
                rcoCbm: parseFloat(requestConsignee.rcoCbm),
                rcoQty: requestConsignee.rcoQty
                  ? parseInt(requestConsignee.rcoQty)
                  : null,
                rcoLocationValue,
                rcoConsigneeValue,
                rcoConsignmentTypeValue,
              },
              id: parseInt(requestConsignee.id),
            }),
          );
        }
      } else {
        dispatch(
          requestActions.updatePersistedConsignee({
            consignee: {
              ...requestConsignee,
              rcoCbm: parseFloat(requestConsignee.rcoCbm),
              rcoQty: requestConsignee.rcoQty
                ? parseInt(requestConsignee.rcoQty)
                : null,
              rcoLocationValue,
              rcoConsigneeValue,
              rcoConsignmentTypeValue,
              modified: true,
            },
            rcoId: parseInt(requestConsignee.rcoId),
          }),
        );
      }
      setButtonClicked(true);
    } else {
      setErrors(requestConsigneeErrors);
      document.querySelector(".ui.form").classList.add("error");
    }
    setIsAddLoading(false);
  };

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <h4 className="ui dividing header">Consignee</h4>
          <div className="field">
            <Dropdown
              readOnly={viewOnlyMode}
              required={true}
              label="Location"
              error={errors.rcoLocation}
              form={FORM}
              module={MODULES.Transaction}
              field="rco_location"
              resetError={() =>
                setErrors((prevState) => {
                  const { rcoLocation: _, ...rest } = prevState;
                  return rest;
                })
              }
              name="Location"
              style={{ height: "20px" }}
              options={locationOptions}
              value={requestConsignee.rcoLocation}
              onChange={(e, data) =>
                setRequestConsignee((prevState) => ({
                  ...prevState,
                  rcoLocation: data.value,
                }))
              }
            />
          </div>
          <div className="two fields">
            <SearchDropdown
              readOnly={viewOnlyMode}
              key={1}
              editMode={editMode}
              multiGrid={true}
              multiGridCurrentValue={requestConsignee.rcoConsigneeValue}
              reset={searchFieldReset}
              form={FORM}
              module={MODULES.Transaction}
              field="rco_consignee"
              setReset={setSearchFieldReset}
              clearable={true}
              onClear={() => {
                setRequestConsignee((prevState) => ({
                  ...prevState,
                  rcoConsignee: null,
                }));
              }}
              onResultSelect={(data) =>
                setRequestConsignee((prevState) => ({
                  ...prevState,
                  rcoConsignee: data,
                }))
              }
              api={getOtherRefSearchDropdown}
              apiDependency={{
                type: "stakeholder_type",
                value: "Consignee",
                param1: requestConsignee.rcoConsignee?.toString(),
              }}
              fieldInfo={{
                tableName: "masterdata.tms_m_stakeholder",
                primaryKey: "stk_id",
                fieldName: "stk_name",
                id: requestConsignee.rcoConsignee,
              }}
              label="Consignee"
              error={errors.rcoConsignee}
              resetError={() =>
                setErrors((prevState) => {
                  const { rcoConsignee: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
            <Dropdown
              required={true}
              readOnly={viewOnlyMode}
              label="Consignment Type"
              error={errors.rcoConsignmentType}
              form={FORM}
              module={MODULES.Transaction}
              field="rco_consignment_type"
              resetError={() =>
                setErrors((prevState) => {
                  const { rcoConsignmentType: _, ...rest } = prevState;
                  return rest;
                })
              }
              name="consigneeConsignmentType"
              style={{ height: "20px" }}
              options={dropdown.consignmentTypeOptions}
              value={requestConsignee.rcoConsignmentType}
              onChange={(e, data) =>
                setRequestConsignee((prevState) => ({
                  ...prevState,
                  rcoConsignmentType: data.value,
                }))
              }
            />
          </div>
          <div className="two fields">
            <Input
              readOnly={viewOnlyMode}
              label="CBM"
              error={errors.rcoCbm}
              form={FORM}
              module={MODULES.Transaction}
              field="rco_cbm"
              resetError={() =>
                setErrors((prevState) => {
                  const { rcoCbm: _, ...rest } = prevState;
                  return rest;
                })
              }
              type="number"
              max={remainingCbm}
              min={0}
              name="cbm"
              placeholder="CBM"
              value={requestConsignee.rcoCbm}
              onChange={(e) => {
                if (parseFloat(e.target.value) + currentTotalCBM > vehMaxCbm) {
                  setErrors({
                    rcoCbm: "Total CBM exceeds vehicle max CBM",
                  });
                } else {
                  setErrors((prevState) => {
                    const { rcoCbm: _, ...rest } = prevState;
                    return rest;
                  });
                }
                setRequestConsignee((prevState) => ({
                  ...prevState,
                  rcoCbm: e.target.value,
                }));
              }}
            />

            <Input
              label="QTY"
              readOnly={viewOnlyMode}
              error={errors.rcoQty}
              form={FORM}
              module={MODULES.Transaction}
              field="rco_qty"
              resetError={() =>
                setErrors((prevState) => {
                  const { rcoQty: _, ...rest } = prevState;
                  return rest;
                })
              }
              type="number"
              name="qty"
              min={0}
              placeholder="QTY"
              value={requestConsignee.rcoQty}
              onChange={(e) => {
                if (parseFloat(e.target.value) < 0) {
                  setErrors({
                    rcoQty: "Should be greater than 0",
                  });
                } else {
                  setErrors((prevState) => {
                    const { rcoQty: _, ...rest } = prevState;
                    return rest;
                  });
                }
                setRequestConsignee((prevState) => ({
                  ...prevState,
                  rcoQty: e.target.value,
                }));
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <Button
              template="reset"
              onClick={(e) => {
                setButtonClicked(true);
              }}
            />
            <Button
              template="addOrSave"
              authenticated={true}
              editMode={editMode}
              module={MODULES.Transaction}
              form={`${FORM}`}
              disabled={viewOnlyMode || Object.keys(errors).length > 0}
              create={Object.keys(currentItem).length === 0}
              onClick={onAddClick}
              isLoading={isAddLoading}
            />
          </div>
          <div
            style={{
              width: "100%",
            }}
          >
            <Grid
              heading="Consignee List"
              config={[
                {
                  headerName: "Location",
                  field: "rcoLocationValue",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                { headerName: "Consignee", field: "rcoConsigneeValue" },
                {
                  headerName: "Consignement Type",
                  field: "rcoConsignmentTypeValue",
                },
                { headerName: "CBM", field: "rcoCbm" },
                { headerName: "QTY", field: "rcoQty" },
                {
                  field: "Edit",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    clickHandler: () => {
                      setCurrentItem(params.data);
                    },
                    label: viewOnlyMode ? "View" : "Edit",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Transaction,
                  }),
                },
                {
                  field: "Delete",
                  filter: true,
                  cellRenderer: DeleteButtonRenderer,
                  cellRendererParams: (params) => ({
                    clickHandler: () => {
                      if (params.data.rcoId && params.data.rcoId !== null) {
                        dispatch(
                          requestActions.removeConsignee({
                            rcoId: params.data.rcoId,
                          }),
                        );
                      } else {
                        dispatch(
                          requestActions.removeUnPersistedConsignee({
                            id: params.data.id,
                          }),
                        );
                      }
                    },
                    label: "Delete",
                    disabled: viewOnlyMode,
                    className: "ui red button",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Transaction,
                  }),
                },
              ]}
              content={filteredList}
            />
          </div>
          {validationErrors && validationErrors.length > 0 && (
            <UIMessage type="negative" width="100%" centered={false}>
              <div className="content">
                <div className="header">
                  There was some errors with the consignees
                </div>

                <p>
                  <div className="content">
                    <ul>
                      {validationErrors.map((value) => (
                        <li>{value.error}</li>
                      ))}
                    </ul>
                  </div>
                </p>
              </div>
            </UIMessage>
          )}
        </div>

        <div className="field contact-container"></div>
      </form>
    </div>
  );
};

export default QuickRequestConsignee;
